import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SubscriptionService } from '../../core/subscription/subscription.service';
import { UserService } from '../../core/user/user.service';
import { SubscriptionDetails } from '../../core/subscription/subscription';

@Injectable({
    providedIn: 'root'
})
export class BillingResolver {
    constructor(
        private subscriptionService: SubscriptionService,
        private userService: UserService
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<SubscriptionDetails | null> {
        const subscriptionId = this.userService.userData?.subscription?.id;

        if (!subscriptionId) {
            return of(null);
        }

        return this.subscriptionService.getSubscriptionDetails(subscriptionId).pipe(
            catchError((error) => {
                console.error('Error fetching subscription details:', error);
                return of(null);
            })
        );
    }
}
